// APP URLS//PAGES

// AUTHENTICATION
export const LOGIN_URL = "/login";

// OFFICE
export const OFFICE_URL = "/offices";
export const OFFICE_LIST_URL = "admin/office-list?page=1";
export const APP_URL = "http://63.250.41.88/api";
// export const APP_URL = `https://prudentapi.insuretech.com.ng/api`;

// STAFFS
export const PAGES = {
  STAFF_LIST_URL: "/admin/list-of-staffs",
  PERSONAL_INFORMATION: "/admin/add-staff",
  CONTACT_INFORMATION: "/admin/add-staff/contact-information",
  EDUCATIONAL_INFORMATION: "/admin/add-staff/education-info",
  EMPLOYMENT_INFORMATION: "/admin/add-staff/employment-information",
  GUARANTOR_INFORMATION: "/admin/add-staff/guarantor-information",
  WORK_EXPERIENCE_INFORMATION: "/admin/add-staff/work-experience",
  NEXT_OF_KIN_INFORMATION: "/admin/add-staff/next-of-kin-information",
};
